//import { SessionState } from "sip.js/lib/core";
//import { Inviter } from "sip.js/lib/api/inviter";
//import * as Datastore from "electron-store";
import Api from '../../plugins/Api';
function getDefault(data) {
    return new Promise((resolve, reject) => {
        let config = JSON.parse(localStorage.getItem("config"))
        Api.http.all([
            Api.http.post(`https://${config.servidor}:8004${data}`).then(res => {
                if (res.data) {
                    resolve(res.data);
                }
            }).catch(err => {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET DEFAULT ERROR] ` + err)
                reject(err);
            })
        ])
    })
}

export default {
    namespaced: true,
    state: {
        registered: false,
        localAudio: '',
        remoteAudio: ``,
        sessions: [],
        calls: [],
        isDiscando: false,
        isOcupado: false,
        isTocando: false,
        historico: [],
        newCall: null,
        newInvite: null,
        rejectCause: '',
        conference: {
            users: []
        },
        status: '',
        lastCall: null,
        db: {},

    },

    mutations: {
        addUserConference(state, dados) {
            let index = state.calls.findIndex(a => dados.uniqueid === a.uniqueid);
            if (index !== -1) {
                let ligacao = state.calls[index];
                if (!ligacao.users) ligacao.users = [];
                ligacao.users.push({ nome: dados.nome, numero: dados.numero, uniqueid: dados.callid, ramal: dados.ramal });
                state.calls.splice(index, 1, ligacao);
                if (ligacao.uniqueid == state.newCall.uniqueid) state.newCall = ligacao;
            }
        },
        removeUserConference(state, dados) {
            let index = state.calls.findIndex(a => dados.uniqueid === a.uniqueid);
            if (index !== -1) {
                let ligacao = state.calls[index];
                if (!ligacao.users) ligacao.users = [];
                let indexUser = ligacao.users.findIndex(u => u.numero == dados.numero);
                ligacao.users.splice(indexUser, 1);
                state.calls.splice(index, 1, ligacao);
            }
        },
        XC_ConferenciaAtt(state, dados) {
            setTimeout(() => {
                console.log(`CONFERENCIA`, dados);
                let ligacao = state.calls.find(l => l.dados["X-Sala"] == dados.dados.sala);
                ligacao.users = [];
                for (let i = 1; i <= dados.dados.campos.qtdParticipantes; i++) {
                    ligacao.users.push({ nome: dados.dados.campos[`nome${i}`], numero: dados.dados.campos[`numero${i}`] });
                }
                console.log(`LIGACAO`, ligacao)
            }, 500);

        },
        XC_Tocando(state, message) {
            console.log(`tocando`, message)
            let atendimento = message;
            if (state.calls.length > 0) {
                let index = state.calls.findIndex(a => atendimento.linkedid === a.uniqueid);
                if (index !== -1) {
                    console.log(`ACHAMOS A CALL`)
                    state.calls[index].atendimento = atendimento;
                } else {
                    console.log(`N ACHAMOS A CALL`)
                }
            }
        },
        XC_AddAtendimento(state, message) {
            console.log(`ADD ATENDIMENTO`)
            let atendimento = message;
            if (state.calls.length > 0) {
                let index = state.calls.findIndex(a => atendimento.linkedid === a.uniqueid);
                if (index !== -1) {
                    console.log(`ENTROU`)
                    let call = state.calls[index];
                    call.atendimento = atendimento;
                    state.calls.splice(index, 1, call);
                    //state.calls[index].atendimento = atendimento;
                    if (state.newCall && state.newCall.uniqueid === atendimento.linkedid) {
                        //console.log(`ENTROU2`)
                        //state.newCall.atendimento = atendimento;
                    }
                }
            }
        },
        XC_Atendeu(state, message) {
            let atendimento = message;
            if (state.calls.length > 0) {
                let index = state.calls.findIndex(a => atendimento.linkedid === a.uniqueid);
                if (index !== -1) {
                    console.log(`ACHAMOS A CALL`)
                    // if (state.calls[index].uniqueid === state.newCall.uniqueid) state.newCall.atendimento = atendimento;
                    let call = state.calls[index];
                    call.atendimento = atendimento;
                    state.calls.splice(index, 1, call);
                    //  state.calls[index].atendimento = atendimento;
                }
            }
        },
        XC_Hangup(state, data) {
            try {
                console.log(`Hangup`, data);
                if (state.calls.length > 0) {
                    let ligacaoIndex = state.calls.findIndex(c => c.uniqueid == data.uniqueid);
                    if (ligacaoIndex == -1) {

                        let ligacao = state.calls.find(c => c.conference);
                        if (!ligacao) return;
                        console.log(`ACHOU A LIGACAO`, ligacao)
                        let userIndex = ligacao.users.findIndex(u => u.numero == data.exten);
                        if (userIndex !== -1) {
                            console.log(`ACHOU O USER`, ligacao.users[userIndex]);
                            ligacao.users.splice(userIndex, 1);
                            state.calls.splice(ligacaoIndex, 1, ligacao);
                        }
                    }
                }
            } catch (error) {
                console.error(error);
            }


            // let atendimento = message;
            // if (state.calls.length > 0) {
            //     let index = state.calls.findIndex(a => atendimento.linkedid === a.uniqueid);
            //     if (index !== -1)
            //         state.calls[index].atendimento = atendimento;
            // }

            // if (state.conference && state.conference.users.length > 0) {
            //     let index = state.conference.users.findIndex(a => atendimento.linkedid == a.uniqueid);
            //     if (index !== -1)
            //         state.conference.users.splice(index, 1);
            // }
        },
        CLEAN_HISTORICO(state) {
            console.log('Chamou mutation pra limpar historico');
            // state.db.delete('historico');
            state.historico = [];
        },
        LOAD_HISTORICO(state) {
            console.log('++++++ Mutation LOAD_HISTORICO +++++++++');
            // state.historico = state.db.get('historico') || [];
        },
        PHONE_statusUpdate(state, status) {
            console.log('Update de status no store');
            console.log(status);
            state.status = status;
        },
        PHONE_sendDTMF(state, data) {
            const session = state.sessions.find(s => s.callid === data.callid);
            if (session) {
                console.log(`sendDTMF ${data.dtmf} para callid = ${data.callid}`);
                session.dtmf(data.dtmf);
            }
            else {
                console.log(`Sessao ${data.callid} nao encontrada`);
            }
        },

        //function to create conference by mixing audio
        //sessions => array with JsSIP.RTCSessions calls
        //remoteAudioId => the ID of your <audio> element to play the received streams
        PHONE_conference(state) {
            let remoteAudioId;
            //take all received tracks from the sessions you want to merge
            let sessions = state.sessions;
            var receivedTracks = [];
            sessions.forEach(function (session) {
                return console.log(session);
                if (session !== null && session !== undefined) {
                    session.connection.getReceivers().forEach(function (receiver) {
                        receivedTracks.push(receiver.track);
                    });
                }
            });
            return;

            //use the Web Audio API to mix the received tracks
            var context = new AudioContext();
            var allReceivedMediaStreams = new MediaStream();

            sessions.forEach(function (session) {
                if (session !== null && session !== undefined) {

                    var mixedOutput = context.createMediaStreamDestination();
                    remoteAudioId = session.media.output.id;
                    session.connection.getReceivers().forEach(function (receiver) {
                        receivedTracks.forEach(function (track) {
                            allReceivedMediaStreams.addTrack(receiver.track);
                            if (receiver.track.id !== track.id) {
                                var sourceStream = context.createMediaStreamSource(new MediaStream([track]));
                                sourceStream.connect(mixedOutput);
                            }
                        });
                    });
                    //mixing your voice with all the received audio
                    session.connection.getSenders().forEach(function (sender) {
                        var sourceStream = context.createMediaStreamSource(new MediaStream([sender.track]));
                        sourceStream.connect(mixedOutput);
                    });
                    session.connection.getSenders()[0].replaceTrack(mixedOutput.stream.getTracks()[0]);
                }
            });

            //play all received stream to you
            var remoteAudio = document.getElementById('remoteAudioId');
            remoteAudio.srcObject = allReceivedMediaStreams;
            var promiseRemote = remoteAudio.play();
            if (promiseRemote !== undefined) {
                promiseRemote.then(_ => {
                    console.log("playing all received streams to you");
                }).catch(error => {
                    console.log(error);
                });
            }
        },
        async PHONE_invite(state, SESSION) {
            try {
                let user = JSON.parse(localStorage.getItem(`user`));
                console.log(`ENTROU NO INVITE`, SESSION);
                SESSION.callid = SESSION.id
                state.sessions.push(SESSION)
                state.isTocando = true;
                let session = SESSION.session;
                const ligacao = {};
                ligacao.dataini = new Date();
                ligacao.nome = session.request.headers['From'][0].parsed._displayName;
                ligacao.numero = session.request.headers['From'][0].parsed.uri.user;
                ligacao.callid = session.request.headers['Call-ID'][0].raw;
                ligacao.idCliente = session.request.headers['X-Idcliente'] ? session.request.headers['X-Idcliente'][0].raw : null
                if (session.request.headers['X-Fila']) ligacao.fila = session.request.headers['X-Fila'][0].raw;
                if (session.request.headers['X-Unique-Id']) ligacao.uniqueid = session.request.headers['X-Unique-Id'][0].raw;
                if (!ligacao.fila) {
                    let filaAux = user.filas[0];
                    let filaVoz = user.filas.find(f => f.queue_type === 1);
                    ligacao.fila = filaVoz ? filaVoz.fila : filaAux.fila;
                    ligacao.addAtendimento = true;
                }
                ligacao.sentido = 'Entrante';
                ligacao.mic = true;
                ligacao.dados = [];
                const d = {};
                Object.keys(session.request.headers).forEach(head => {
                    if (head.startsWith('X-')) {
                        d[head] = session.request.headers[head][0].raw;
                        ligacao.dados = d;
                    }
                });
                if (ligacao.dados["X-Conferencia"]) {
                    ligacao.conference = true;
                    // let conference = localStorage.getItem(`conference`);
                    // if (conference) {
                    //     conference = JSON.parse(conference);
                    //     state.conference = conference;
                    // }
                    // state.conference.callid = ligacao.callid;
                }
                // if (ligacao.uniqueid) ligacao.dados["X-protocolo"] = ligacao.uniqueid;

                state.isOcupado = true;
                state.calls.push(ligacao);
                state.newInvite = null;
                state.newInvite = ligacao;
                console.log(`atualizamos o newCall`, state.newCall);
                let { accepted, rejectCause } = await SESSION.accepted();
                if (!accepted) {
                    console.log(`Nao aceitamos`)
                    console.log(rejectCause);
                    this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [INVITE REJECT CAUSE ] ` + rejectCause)

                    //Caso nao atendeu apenas vamos esperar essa bagaca
                    return await SESSION.terminated();
                }
                ligacao.atendida = true;
                let index = state.calls.findIndex(c => c.callid === ligacao.callid);
                state.calls.splice(index, 1, ligacao);
                await SESSION.terminated();

            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [INVITE CATCH] ` + error)
                console.error(error);
            } finally {
                console.log('<<<<< terminated WEBPHONE no Mutation');
                state.isOcupado = false;
                state.isTocando = false;
                state.isDiscando = false;

                let callid = SESSION.callid;
                const index = state.sessions.findIndex(s => s.callid === callid);
                if (index !== -1) {
                    console.log(`Removendo session no id ${index}`);
                    state.sessions.splice(index, 1);
                }
                const idxCall = state.calls.findIndex(l => l.callid === callid);
                if (idxCall !== -1) {
                    if (state.calls[idxCall].atendimento) {
                        let encerrar = getDefault(
                            `/api/v2/chat/encerrar/${state.calls[idxCall].atendimento.id}`
                        );
                    }

                    console.log(`Removendo Ligacao`, state.calls[idxCall]);
                    state.calls[idxCall].datafim = new Date();
                    state.historico.push(state.calls[idxCall]);
                    // state.db.set('historico', state.historico);
                    state.lastCall = state.calls[idxCall];
                    if (state.newInvite && state.newInvite.callid === state.calls[idxCall].callid) state.newInvite = null;
                    if (state.newCall && state.newCall.callid === state.calls[idxCall].callid) state.newCall = null;
                    state.calls.splice(idxCall, 1);
                    console.log(`passou aqui`);
                }
                state.isOcupado = false;
            }
        },
        async PHONE_Atender(state, callId) {
            try {
                state.isOcupado = false;
                state.isTocando = false;
                state.newInvite.pause = false;
                state.newCall = state.newInvite;
                console.log(`ATENDEMOS`, state.newCall)
                var session = state.sessions.find(s => s.callid === callId);
                if (session) {
                    console.log(`achamos a ligacao`, session);
                    session.session.accept();
                    //Bora pausar as outras ligacoes caso tenha
                    if (state.calls.length > 1) {
                        let calls = state.calls.filter(c => c.callid !== callId);
                        for (let call of calls) {
                            let sessionAUx = state.sessions.find(s => s.callid === call.callid);
                            if (sessionAUx) {
                                sessionAUx.hold();
                            }
                            call.pause = true;
                        }
                    }

                }

            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [ATENDER ERROR] ` + error)
                let sessionIndex = state.sessions.findIndex(s => s.callid === callId);
                state.sessions.splice(sessionIndex, 1);
                let idxCall = state.calls.findIndex(s => s.callid === callId);
                state.calls.splice(idxCall, 1);
                console.error(error)
            }
        },
        async PHONE_terminated(state, invite) {

            state.isOcupado = false;
            state.isTocando = false;
            state.isDiscando = false;
            console.log('<<<<< terminated WEBPHONE no Mutation');
            if (state.calls.length > 0) {
                state.isOcupado = true;
            }
            if (state.calls.length > 0 && state.calls.find(c => !c.atendida)) {
                console.log(`---------entrou aqui--------------------`)
                state.isTocando = true;
            }

            invite.callid = invite.id;
            let callid = invite.callid;
            const index = state.sessions.findIndex(s => s.callid === callid);
            if (index !== -1) {
                console.log(`Removendo session no id ${index}`);
                state.sessions.splice(index, 1);
            }
            const idxCall = state.calls.findIndex(l => l.callid === callid);
            if (idxCall !== -1) {

                console.log(`Removendo Ligacao`, state.calls[idxCall]);
                state.calls[idxCall].datafim = new Date();
                state.historico.push(state.calls[idxCall]);
                // state.db.set('historico', state.historico);
                state.lastCall = state.calls[idxCall];
                if (state.calls[idxCall].atendimento) {
                    let encerrar = getDefault(
                        `/api/v2/chat/encerrar/${state.calls[idxCall].atendimento.id}`
                    );
                }
                if (state.newInvite && state.newInvite.callid === state.calls[idxCall].callid) state.newInvite = null;
                if (state.newCall && state.newCall.callid === state.calls[idxCall].callid) state.newCall = null;
                state.calls.splice(idxCall, 1);

            }
            state.isOcupado = false;
        },
        PHONE_setOutputVolumeAll(state, volume) {
            for (let session of state.sessions) {
                session.media.output.volume = volume;
            }
        },
        PHONE_setInputVolumeAll(state, volume) {
            for (let session of state.sessions) {
                session.media.input.volume = volume;
                session.media.input.muted = false;
            }
        },
        PHONE_setInputMuteAll(state, muted) {
            for (let session of state.sessions) {
                session.media.input.muted = muted;
            }
        },
        PHONE_setOutputMuteAll(state, muted) {
            for (let session of state.sessions) {
                session.media.output.muted = muted;
            }
        },
        PHONE_setInputMuteSession(state, data) {
            const session = state.sessions.find(s => s.callid === data.callid);
            if (session) session.media.input.muted = !data.mic;
        },
        PHONE_changeDevices(state, data) {
            for (let session of state.sessions) {
                session.media.setInput({
                    id: data.inputDevice,
                    audioProcessing: true,
                    volume: session.media.input.volume,
                    muted: session.media.input.muted
                });
                session.media.setInput({
                    id: data.outputDevice,
                    audioProcessing: true,
                    volume: session.media.output.volume,
                    muted: session.media.output.muted
                });
            }

        },
        SET_LocalAudio(state, audio) {
            state.localAudio = audio;
        },
        SET_RemoteAudio(state, audio) {
            state.remoteAudio = audio;
        },
        SET_Atender(state, callId) {
            state.isOcupado = false;
            state.isTocando = false;
            var session = state.sessions.find(s => s.session.callId === callId);
            if (session) {
                session.accept({
                    sessionDescriptionHandlerOptions: {
                        constraints: {
                            audio: true,
                            video: false
                        }
                    }
                });
            }
            const ci = state.calls.findIndex(l => l.callid === callId);
            if (ci !== -1) {
                var call = state.calls[ci];
                call.atendida = true;
                state.calls.splice(ci, 1, call);
            }

        },
        // SET_Desligar(state, callId) {
        //     var session = state.sessions.find(s => s.request.callid === callId || s.session.callId === callId);
        //     if (session) {
        //         // this._vm.$VueSipJS.desligar(session);
        //         // console.log(state.calls);               
        //         session.cancel();
        //         session.bye();
        //         // session.reject();    

        //     }
        // },
        SET_Desligar(state, callId) {
            try {
                const session = state.sessions.find(s => s.callid === callId);
                if (session) {
                    console.log(`ACHEI`)
                    session.terminate();
                } else {
                    let idx = state.calls.findIndex(s => s.callid === callId);
                    if (idx !== -1) state.calls.splice(idx, 1);
                    state.newCall = null
                }
                if (state.conference && state.conference.callid == callId) {
                    state.conference = {};
                    state.conference.users = [];
                    localStorage.setItem(`conference`, JSON.stringify(state.conference));

                }
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [HANGUP ERROR] ` + error)
                let sessionIndex = state.sessions.findIndex(s => s.callid === callId);
                state.sessions.splice(sessionIndex, 1);
                let idxCall = state.calls.findIndex(s => s.callid === callId);
                state.calls.splice(idxCall, 1);
                console.error(error)
            }

            // if (state.newCall.callid === session.callid) state.newCall = null;
            //codigo antigo sipjs
            // var session = state.sessions.find(s => s.request.callId === callId || s.session.callId === callId);
            // if (session) {
            //     if (session.session) {
            //         session.bye();
            //     } else {
            //         session.cancel();
            //     }

            // }
        },
        async PHONE_Transferir(state, payload) {
            try {
                var session = state.sessions.find(s => s.callid === payload.callid);
                if (session) {
                    if (payload.callidDestino) {
                        var sessionDestino = state.sessions.find(s => s.callid === payload.callidDestino);
                        if (sessionDestino) {
                            console.log(`ACHAMOS A SESSION===============`);
                            sessionDestino.attendedTransfer(session);
                            //await session.attendedTransfer(sessionDestino);
                        }
                    }
                    else {
                        await session.blindTransfer(payload.destino);
                    }
                    //state.isOcupado = false;
                }
                let idxcall = state.calls.findIndex(c => c.callid === payload.callid);
                if (state.calls[idxCall].atendimento) {
                    let encerrar = getDefault(
                        `/api/v2/chat/encerrar/${state.calls[idxCall].atendimento.id}`
                    );
                }
                state.newCall = null;
                if (idxcall !== -1) state.calls.splice(idxcall, 1);
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [TRANSFERIR ERROR] ` + error);
                console.error(error);
            }

        },
        SET_Transferir(state, payload) {
            var session = state.sessions.find(s => s.session.callId === payload.callid);
            if (session) {
                if (payload.callidDestino) {
                    var sessionDestino = state.sessions.find(s => s.request.callId === payload.callidDestino || s.session.callId === payload.callidDestino);
                    if (sessionDestino) {
                        session.refer(sessionDestino);
                    }
                }
                else {
                    session.refer(payload.destino);
                }
                //state.isOcupado = false;
            }
        },
        SET_MicOnOff(state, payload) {
            var session = state.sessions.find(s => s.request.callId === payload.callid || s.session.callId === payload.callid);
            if (session) {
                const pc = session.sessionDescriptionHandler.peerConnection
                pc.getSenders().forEach((stream) => {
                    stream.track.enabled = payload.mic
                })
            }
            const ci = state.calls.findIndex(l => l.callid === payload.callid);
            if (ci !== -1) {
                var call = state.calls[ci];
                call.mic = payload.mic;
                state.calls.splice(ci, 1, call);
            }
        },
        PHONE_Espera(state, callId) {
            try {
                var session = state.sessions.find(s => s.callid === callId);
                if (session) {
                    session.hold();
                }
                const ci = state.calls.findIndex(l => l.callid === callId);
                if (ci !== -1) {
                    var call = state.calls[ci];
                    call.pause = true;
                    state.calls.splice(ci, 1, call);
                }
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [ESPERA ERROR] ` + error)
                let sessionIndex = state.sessions.findIndex(s => s.callid === callId);
                state.sessions.splice(sessionIndex, 1);
                let idxCall = state.calls.findIndex(s => s.callid === callId);
                state.calls.splice(idxCall, 1);
                console.error(error);
            }
        },
        SET_Espera(state, callId) {
            var session = state.sessions.find(s => s.request.callid === callId || s.session.callId === callId);
            if (session) {
                session.hold();
            }
            const ci = state.calls.findIndex(l => l.callid === callId);
            if (ci !== -1) {
                var call = state.calls[ci];
                call.pause = true;
                state.calls.splice(ci, 1, call);
            }
        },
        PHONE_TiraEspera(state, callId) {
            try {
                var session = state.sessions.find(s => s.callid === callId);
                if (session) {
                    session.unhold();
                }
                const ci = state.calls.findIndex(l => l.callid === callId);
                if (ci !== -1) {
                    var call = state.calls[ci];
                    call.pause = false;
                    state.calls.splice(ci, 1, call);
                }
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [TIRA ESPERA ERROR] ` + error)
                let sessionIndex = state.sessions.findIndex(s => s.callid === callId);
                state.sessions.splice(sessionIndex, 1);
                let idxCall = state.calls.findIndex(s => s.callid === callId);
                state.calls.splice(idxCall, 1);
                console.error(error);
            }

        },
        SET_TiraEspera(state, callId) {
            var session = state.sessions.find(s => s.request.callId === callId || s.session.callId === callId);
            if (session) {
                session.unhold();
            }
            const ci = state.calls.findIndex(l => l.callid === callId);
            if (ci !== -1) {
                var call = state.calls[ci];
                call.pause = false;
                state.calls.splice(ci, 1, call);
            }
        },
        async SET_Discando(state, destino) {
            //state.isOcupado = true;
            let config = JSON.parse(localStorage.getItem(`config`));
            let user = JSON.parse(localStorage.getItem(`user`));
            const session = await this._vm.$WebPhone.client.invite(destino);
            try {
                state.isDiscando = true;
                // state.isDiscando = false;
                let callid, numero;
                callid = session.id;
                session.callid = session.id ? session.id : session.session.id;
                numero = session.session.remoteIdentity.uri.user;
                //Vamos adicionar a session no nosso array de sessions para usa-la após
                state.sessions.push(session);
                const ligacao = {};

                ligacao.dataini = new Date();
                ligacao.nome = '';
                ligacao.numero = numero;
                ligacao.callid = callid;
                ligacao.dados = [];
                let filaAux = user.filas[0];
                let filaVoz = user.filas.find(f => f.queue_type === 1);
                ligacao.fila = filaVoz ? filaVoz.fila : filaAux.fila;
                ligacao.addAtendimento = true;
                const d = {};
                // Object.keys(session.session.request.headers).forEach(head => {
                //     if (head.startsWith('X-')) {
                //         d[head] = session.session.request.headers[head][0].raw;
                //         console.log(head);
                //         console.log(d[head]);
                //     }
                // });
                // d['X-Callid'] = session.session.request.headers['X-Callid'][0];
                // ligacao.dados = d;
                //   ligacao.dados["X-Unique-Id"] = session.session.request.headers["Call-ID"][0];
                //ligacao.uniqueid = session.session.request.headers["Call-ID"][0];
                ligacao.uniqueid = session.session.request.headers['X-Callid'] ? session.session.request.headers['X-Callid'][0] : ligacao.callid;
                // if (ligacao.uniqueid) ligacao.dados["X-protocolo"] = ligacao.uniqueid;
                ligacao.sentido = 'Sainte';
                ligacao.mic = true;
                ligacao.atendida = true;
                state.calls.push(ligacao);
                state.newCall = ligacao;
                console.log(`ADICIONAMOS A LIGACAO`, ligacao)
                let { accepted, rejectCause } = await session.accepted();
                //Bora pausar as outras ligacoes caso tenha
                if (state.calls.length > 1) {
                    let calls = state.calls.filter(c => c.callid !== ligacao.callid);
                    for (let call of calls) {
                        let sessionAUx = state.sessions.find(s => s.callid === call.callid);
                        if (sessionAUx && call.atendida) {
                            sessionAUx.hold();
                        }
                        call.pause = true;
                    }
                }
                if (!accepted) {
                    //Vamos fazer alguma coisa....
                    console.log(`Nao atenderam fius`);
                    state.rejectCause = rejectCause;
                    this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [DISCAR REJECT] ` + rejectCause);

                }
                state.isDiscando = false;
                await session.terminated();
            } catch (e) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [DISCAR ERROR] ` + e)
                state.rejectCause = e;
                const idxCall = state.calls.findIndex(l => l.callid === session.id);
                if (idxCall !== -1) {
                    state.lastCall = state.calls[idxCall];
                    state.calls.splice(idxCall, 1);
                    if (state.newCall && state.newCall.callid === session.id) state.newCall = null;
                }
            } finally {
                console.log('<<<<< terminated WEBPHONE no Mutation');
                state.isOcupado = false;
                state.isTocando = false;
                state.isDiscando = false;
                if (state.calls.length > 0) {
                    state.isOcupado = true;
                }
                if (state.calls.length > 0 && state.calls.find(c => !c.atendida)) {
                    console.log(`---------entrou aqui--------------------`)
                    state.isTocando = true;
                }


                let callid = session.callid;
                const index = state.sessions.findIndex(s => s.callid === callid);
                if (index !== -1) {
                    console.log(`Removendo session no id ${index}`);
                    state.sessions.splice(index, 1);
                }
                const idxCall = state.calls.findIndex(l => l.callid === callid);
                if (idxCall !== -1) {

                    console.log(`Removendo Ligacao no id ${idxCall}`);
                    state.calls[idxCall].datafim = new Date();
                    state.historico.push(state.calls[idxCall]);
                    // state.db.set('historico', state.historico);
                    state.lastCall = state.calls[idxCall];
                    if (state.newCall.callid === state.calls[idxCall].callid) state.newCall = null;
                    if (state.calls[idxCall].atendimento) {
                        let encerrar = getDefault(
                            `/api/v2/chat/encerrar/${state.calls[idxCall].atendimento.id}`
                        );
                    }

                    state.calls.splice(idxCall, 1);
                }
                state.isOcupado = false;
            }


        },
        async SET_DiscandoTransferencia(state, destino) {
            //state.isOcupado = true;
            let config = JSON.parse(localStorage.getItem(`config`));
            let user = JSON.parse(localStorage.getItem(`user`));
            const session = await this._vm.$WebPhone.client.invite(destino);
            try {
                console.log(session.session.request.headers);
                state.isDiscando = true;
                // state.isDiscando = false;
                let callid, numero;
                callid = session.id;
                session.callid = session.id ? session.id : session.session.id;
                numero = session.session.remoteIdentity.uri.user;
                //Vamos adicionar a session no nosso array de sessions para usa-la após
                state.sessions.push(session);
                const ligacao = {};
                ligacao.dataini = new Date();
                ligacao.nome = '';
                ligacao.numero = numero;
                ligacao.callid = callid;
                ligacao.dados = [];
                let filaAux = user.filas[0];
                let filaVoz = user.filas.find(f => f.queue_type === 1);
                ligacao.fila = filaVoz ? filaVoz.fila : filaAux.fila;
                const d = {};
                Object.keys(session.session.request.headers).forEach(head => {
                    if (head.startsWith('X-')) {
                        d[head] = session.session.request.headers[head][0].raw;
                        console.log(d[head]);
                    }
                });
                ligacao.dados = d;
                ligacao.dados["X-Unique-Id"] = session.session.request.headers["Call-ID"][0];
                ligacao.uniqueid = session.session.request.headers["Call-ID"][0];
                // if (ligacao.uniqueid) ligacao.dados["X-protocolo"] = ligacao.uniqueid;
                ligacao.sentido = 'Sainte';
                ligacao.mic = true;
                ligacao.atendida = true;

                //Bora pausar as outras ligacoes caso tenha
                if (state.calls.length > 0) {
                    let calls = state.calls;
                    for (let call of calls) {
                        let sessionAUx = state.sessions.find(s => s.callid === call.callid);
                        if (sessionAUx && call.atendida) {
                            sessionAUx.hold();
                        }
                        call.pause = true;
                    }
                }
                state.calls.push(ligacao);
                //state.newCall = ligacao;
                console.log(`ADICIONAMOS A LIGACAO`, ligacao)
                let { accepted, rejectCause } = await session.accepted();

                if (!accepted) {
                    //Vamos fazer alguma coisa....
                    console.log(`Nao atenderam fius`);
                    state.rejectCause = rejectCause;
                    this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [DISCAR REJECT] ` + rejectCause);
                }
                state.isDiscando = false;
                await session.terminated();
            } catch (e) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [DISCAR ERROR] ` + e);

                state.rejectCause = e;
            } finally {
                console.log('<<<<< terminated WEBPHONE no Mutation');
                state.isOcupado = false;
                state.isTocando = false;
                state.isDiscando = false;
                console.log('<<<<< terminated WEBPHONE no Mutation');
                if (state.calls.length > 0) {
                    state.isOcupado = true;
                }
                if (state.calls.length > 0 && state.calls.find(c => !c.atendida)) {
                    console.log(`---------entrou aqui--------------------`)
                    state.isTocando = true;
                }


                let callid = session.callid;
                const index = state.sessions.findIndex(s => s.callid === callid);
                if (index !== -1) {
                    console.log(`Removendo session no id ${index}`);
                    state.sessions.splice(index, 1);
                }
                const idxCall = state.calls.findIndex(l => l.callid === callid);
                if (idxCall !== -1) {

                    console.log(`Removendo Ligacao no id ${idxCall}`);
                    state.calls[idxCall].datafim = new Date();
                    state.historico.push(state.calls[idxCall]);
                    // state.db.set('historico', state.historico);
                    state.lastCall = state.calls[idxCall];
                    if (state.calls[idxCall].atendimento) {
                        let encerrar = getDefault(
                            `/api/v2/chat/encerrar/${state.calls[idxCall].atendimento.id}`
                        );
                    }
                    //if (state.newCall.callid === state.calls[idxCall].callid) state.newCall = null;
                    state.calls.splice(idxCall, 1);
                }
                state.isOcupado = false;
            }


        },
        SIP_accepted(state) {
            state.isDiscando = false;
        },
        SIP_registrationFailed(state, error) {
            state.registered = false;
            console.error(error)
        },
        SIP_registered(state) {
            state.registered = true;
        },
        SIP_unregistered(state) {
            state.registered = false;
        },
        SIP_invite(state, session) {
            console.log('>>>>>> SIP_invite <<<<<<<<<');

            state.sessions.push(session);
            state.isTocando = true;

            const ligacao = {};
            ligacao.dataini = new Date();
            ligacao.nome = session.request.headers['From'][0].parsed._displayName;
            ligacao.numero = session.request.headers['From'][0].parsed.uri.user;
            ligacao.callid = session.request.headers['Call-ID'][0].raw;
            ligacao.sentido = 'Entrante';
            ligacao.mic = true;
            ligacao.dados = [];
            Object.keys(session.request.headers).forEach(head => {
                if (head.startsWith('X-')) {
                    const d = {};
                    d[head] = session.request.headers[head][0].raw;
                    ligacao.dados.push(d);
                }
            });
            state.isOcupado = true;
            state.calls.push(ligacao);
            console.log(`call`, ligacao);
        },
        SIP_failed(state, data) {
            state.isOcupado = false;
            console.log('FAILED', data);
        },
        SIP_trackAdded(state, session) {
            try {
                console.log(">>>>> trackAdded <<<<<<<<<< ");

                var pc = session.sessionDescriptionHandler.peerConnection;
                var remoteStream = new MediaStream();
                pc.getReceivers().forEach(function (receiver) {
                    remoteStream.addTrack(receiver.track);
                });
                state.localAudio.srcObject = remoteStream;
                let callid, numero;
                if (!session.session) {
                    callid = session.request.callId;
                    numero = session.request.ruri.normal.user;

                }
                else {
                    callid = session.session.callId;
                    numero = session.session.remoteURI.user;
                }
                // Ligacao sainte
                const index = state.sessions.findIndex(s => s.request.callId === callid || s.session.callId === callid);
                if (index === -1) {
                    console.log(`Possivel ligação sainte...`);
                    state.sessions.push(session);

                    const ligacao = {};
                    ligacao.dataini = new Date();
                    ligacao.nome = '';
                    ligacao.numero = numero;
                    ligacao.callid = callid;
                    ligacao.dados = [];
                    ligacao.sentido = 'Sainte';
                    ligacao.mic = true;
                    ligacao.atendida = true;
                    state.calls.push(ligacao);
                } else {
                    state.sessions.splice(index, 1, session);
                }
            } catch (error) {
                console.error('Erro', error);
            }

        },
        SIP_directionChanged(state, session) {
            console.log('>>>>>>>>>>>>> SIP_directionChanged >>>>>>>>>');
            console.log(state);
            console.log(session);

            /**
            state.isTocando = false;
            if (session.session && session.session.callId) {
                const ci = state.calls.findIndex(l => l.callid === session.session.callId);
                if (ci !== -1) {
                    console.log(`Achei ligacao, mudando status..`);
                    var call = state.calls[ci];
                    call.pause = session.localHold;
                    call.atendida = session.hasAnswer;
                    state.calls.splice(ci, 1, call);
                }
            }
            **/
        },
        SIP_terminated(state, invite) {
            console.log('<<<<< terminated no Mutation');
            state.isOcupado = false;
            state.isTocando = false;
            state.isDiscando = false;
            let callid = invite.callId ? invite.callId : invite.request.callId || invite.session.callId;
            const index = state.sessions.findIndex(s => s.request.callId === callid || s.session.callId === callid);
            if (index !== -1) {
                console.log(`Removendo session no id ${index}`);
                state.sessions.splice(index, 1);
            }
            const idxCall = state.calls.findIndex(l => l.callid === callid);
            if (idxCall !== -1) {

                console.log(`Removendo Ligacao no id ${idxCall}`);
                state.calls[idxCall].datafim = new Date();
                state.historico.push(state.calls[idxCall]);
                state.calls.splice(idxCall, 1);
            }
            state.isOcupado = false;
        },
        setHistorico(state, data) {
            state.historico = data;
        },
        selectNewCall(state, data) {
            state.newCall = data;
        }
    },
    actions: {
        addLocalAudio({ commit }, audio) {
            commit('SET_LocalAudio', audio);
        },
        conference({ commit }) {
            commit(`PHONE_conference`);
        },
        addRemoteAudio({ commit }, audio) {
            commit(`SET_RemoteAudio`, audio)
        },
        atender({ commit }, callid) {
            commit('PHONE_Atender', callid);
        },
        desligar({ commit }, callid) {
            commit('SET_Desligar', callid);
        },
        Pausar({ commit }, callid) {
            commit('PHONE_Espera', callid);
        },
        Despausar({ commit }, callid) {
            commit('PHONE_TiraEspera', callid);
        },
        MicOnOff({ commit }, payload) {
            console.log(payload);
            commit('PHONE_setInputMuteSession', payload);
        },
        Transferir({ commit }, payload) {
            commit('PHONE_Transferir', payload);
        },
        setVolumeMic({ commit }, volume) {
            try {
                commit(`PHONE_setInputVolumeAll`, volume);
                this._vm.$WebPhone.client.defaultMedia.input.volume = volume;
            } catch (error) {
                console.error(error);
            }


        },
        setVolumePhone({ commit }, volume) {
            try {
                commit(`PHONE_setOutputVolumeAll`, volume);
                this._vm.$WebPhone.client.defaultMedia.output.volume = volume;
            } catch (error) {
                console.error(error)
            }

        },
        setMuteMicAll({ commit }, data) {
            try {
                commit(`PHONE_setInputMuteAll`, data);
                this._vm.$WebPhone.client.defaultMedia.input.muted = data;
            } catch (error) {
                console.error(error)
            }

        },
        setMutePhoneAll({ commit }, data) {
            try {
                commit(`PHONE_setOutputMuteAll`, data);
                this._vm.$WebPhone.client.defaultMedia.output.muted = data;
            } catch (error) {
                console.error(error)
            }

        },
        removeUserConference({ commit }, data) {
            try {
                let config = JSON.parse(localStorage.getItem("config"))
                let user = JSON.parse(localStorage.getItem("user"))
                let dados = {};
                dados.destino = data.ramal ? data.ramal : data.numero;
                dados.causa = 16;
                Api.http.all([
                    Api.http.post(`https://${config.servidor}:8004/api/v2/ligacao/desligar`, dados).then((retorno) => {
                        console.log(`retorno`, retorno);
                        if (retorno.data) {
                            commit(`removeUserConference`, data);
                        }
                    })
                ])
            } catch (error) {
                console.error(error);

            }
        },
        async addUserConference({ commit }, data) {

            return new Promise(async (resolve, reject) => {
                try {
                    let config = JSON.parse(localStorage.getItem("config"))
                    let user = JSON.parse(localStorage.getItem("user"))
                    let dados = {};
                    // dados.origem = data.numero;
                    dados.destino = data.numero;
                    dados.campos = {};
                    dados.campos.sala = data.sala;
                    dados.campos.conferencia = true;
                    dados.campos.qtdParticipantes = data.qtdParticipantes;
                    for (let i = 1; i <= data.qtdParticipantes; i++) {
                        dados.campos[`nome${i}`] = data.users[i - 1].nome;
                        dados.campos[`numero${i}`] = data.users[i - 1].numero;
                    }
                    console.log(`Aqui`, dados);
                    dados.destino_nome = data.nome;
                    dados.rota = user.contexto;
                    dados.max_chamar = 30;
                    dados.sala = data.sala;
                    Api.http.all([
                        Api.http.post(`https://${config.servidor}:8004/api/v4/ligacao/Conferencia`, dados).then((retorno) => {
                            console.log(`retorno`, retorno);
                            if (retorno.data) {
                                data.callid = retorno.data.callid;
                                commit(`addUserConference`, data);
                                resolve(data);
                            }
                        })
                    ])
                } catch (error) {
                    reject(error);
                    console.error(error);

                }
            })


        },
        changeDevices({ commit }, data) {
            try {
                commit(`PHONE_changeDevices`, data);
                this._vm.$WebPhone.client.defaultMedia.output.id = data.outputDevice;
                this._vm.$WebPhone.client.defaultMedia.input.id = data.inputDevice;

            } catch (error) {
                console.error(error)
            }

        },
        selectNewCall({ commit }, call) {
            commit('selectNewCall', call);
        },
        async ligar({ commit }, destino) {
            try {
                commit('SET_Discando', destino);
            } catch (error) {
                console.error(error)
            }

        },
        ligarTransferencia({ commit }, destino) {
            commit(`SET_DiscandoTransferencia`, destino);
        },
        setHistorico({ commit }, data) {
            commit("setHistorico", data);
        },
        loadHistorico({ commit }) {
            commit('LOAD_HISTORICO');
        },
        cleanHistorico({ commit }) {
            commit('CLEAN_HISTORICO');
        }
    },
    getters: {

    }
}